import React from "react";
import ListDataKumpulanDataCompOpenData from "../../../components/open_data/kumpulan_data/ListDataKumpulanDataCompOpenData";
import SearchKumpulanDataCompOpenData from "../../../components/open_data/kumpulan_data/SearchKumpulanDataCompOpenData";

const ListDataKumpulanDataOpenData = () => {
    return (
        <div>
            <SearchKumpulanDataCompOpenData />
            <ListDataKumpulanDataCompOpenData />
        </div>
    );
};

export default ListDataKumpulanDataOpenData;